module.exports = __webpack_public_path__ + "static/media/rask.cce23878.m4a";